import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
export var Tags = /*#__PURE__*/function () {
  function Tags() {
    _classCallCheck(this, Tags);
  }

  _createClass(Tags, null, [{
    key: "filterByCategory",
    value: function filterByCategory(allTags, category) {
      var _category$tagSettings;

      if (!(allTags !== null && allTags !== void 0 && allTags.length) || !(category !== null && category !== void 0 && (_category$tagSettings = category.tagSettings) !== null && _category$tagSettings !== void 0 && _category$tagSettings.length)) {
        return [];
      }

      var categoryTagSettings = category.tagSettings;
      return allTags.filter(function (tag) {
        return categoryTagSettings.some(function (tagSetting) {
          return tagSetting.tagId === tag.id.toString();
        });
      });
    }
  }, {
    key: "filterSelectedKeys",
    value: function filterSelectedKeys(selectedTagKeys, availableTags) {
      if (!(selectedTagKeys !== null && selectedTagKeys !== void 0 && selectedTagKeys.length)) {
        return [];
      }

      var allowedKeys = new Set(availableTags.map(function (tag) {
        return tag.key;
      }));
      return selectedTagKeys.filter(function (key) {
        return allowedKeys.has(key);
      });
    }
  }]);

  return Tags;
}();